import { render, staticRenderFns } from "./LogoutFromBackoffice.vue?vue&type=template&id=48b1b636&"
import script from "./LogoutFromBackoffice.vue?vue&type=script&lang=js&"
export * from "./LogoutFromBackoffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports